import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { AuditLog } from '../../../shared/models';
import { BaseService } from '../../../shared/services/base.service';
import {
  ShelfReplenishmentPhotoListResponse,
  ShelfReplenishmentPhotoSearchCriteria,
  ShelfReplenishmentPhotoTaskSummaryResponse,
  ShelfReplenishmentPhotoView
} from '../model/shelf-replenishment-photo.model';

@Injectable({ providedIn: 'root' })
export class ShelfReplenishmentPhotoService extends BaseService {
  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.shelfReplenishmentPhoto;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  shelfReplenishmentPhotoView(payload): Observable<ShelfReplenishmentPhotoView> {
    const url = this.getFullUrl(this.envService.view, {
      jobNo: payload.payload.jobNo
    });

    return this.http.get<ShelfReplenishmentPhotoView>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }

  shelfReplenishmentPhotoActionSubmitRequest(payload): Observable<any> {
    const url = this.getFullUrl(this.envService.submit, { jobNo: payload.payload.jobNo });
    return this.http.post<any>(url, payload.payload, {
      headers: this.loaderHeaders(3000),
      observe: 'body'
    });
  }

  shelfReplenishmentPhotoActionHistoryRequest(payload): Observable<AuditLog[]> {
    const url = this.getFullUrl(this.envService.history, {
      jobNo: payload.payload.payload.jobNo
    });

    return this.http
      .get<any>(url, {
        headers: this.headers,
        observe: 'body'
      })
      .pipe(map(response => response.historyActivities as AuditLog[]));
  }

  shelfReplenishmentPhotoListRequest(
    requestBody: ShelfReplenishmentPhotoSearchCriteria
  ): Observable<ShelfReplenishmentPhotoListResponse> {
    const url = this.getFullUrl(this.envService.list);
    const params = this.getParams(requestBody, true);
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  shelfReplenishmentPhotoTaskSummaryRequest(): Observable<ShelfReplenishmentPhotoTaskSummaryResponse> {
    const url = this.getFullUrl(this.envService.summary);
    return this.http.get<any>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
